module.exports = __webpack_public_path__ + "static/media/youtube.ee528d4f.svg";